<template>
  <b-card no-body class="table-list">
    <b-card-header class="table-list-header">
      <b-card-title class="table-list-title" title-tag="h6">
        {{ title }}
      </b-card-title>
      <b-button
        v-if="btnText !== ''"
        :variant="btnVariant"
        @click="btnClicked"
        :disabled="disabledBtn"
      >
        {{ btnText }}
      </b-button>
    </b-card-header>
    <b-card-body>
      <slot></slot>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: "MainPageService",
  props: {
    title: { type: String, required: true },
    btnText: { type: String, required: true },
    btnVariant: { type: String, default: "outline-secondary" },
    disabledBtn: { type: Boolean, default: false }
  },
  methods: {
    btnClicked: function() {
      this.$emit("btnCreateClicked");
    }
  }
};
</script>

<style lang="scss">
.table-list {
  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: transparent;
    border: 0;
    padding-top: 20px;
    background-color: #fff;
  }
  &-title {
    display: inline-block;
    margin: 0;
  }
  &-tbody-tr {
    background: #fff;
    &:hover {
      background: #eee;
      cursor: pointer;
    }
    & td {
      vertical-align: middle;
    }
  }
  &-operation {
    margin: 5px;
  }
  &-thead-tr {
    background: #6c757d;
    color: #fff;
  }
}
</style>
